// Definição do tipo BlogPost
interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  date: string;
  readTime: string;
  author: {
    name: string;
    role: string;
    avatar: string;
  };
  image: string;
  slug: string;
  content?: string;
  featured?: boolean;
}

export const blogPosts: BlogPost[] = [
  {
    id: 'reforma-tributaria-consumo',
    title: 'Reforma Tributária do Consumo: o que muda e por que ela é considerada histórica?',
    slug: 'reforma-tributaria-consumo',
    excerpt: 'A maior transformação do sistema tributário brasileiro desde 1988. Entenda os pilares, impactos e mudanças que afetam empresas e consumidores.',
    category: 'Reforma Tributária',
    date: '2025-01-15',
    readTime: '12 min',
    author: 'Equipe Ativo News',
    image: 'https://public.readdy.ai/ai/img_res/629a739a635587971da5cc1beac97bca.jpg',
    featured: true
  },
  {
    id: 1,
    title: 'Gestão de Ativos Fixos: Guia Completo para Contadores',
    slug: 'gestao-ativos-fixos',
    excerpt: 'Entenda como gerenciar adequadamente os ativos fixos da empresa e garantir conformidade fiscal.',
    category: 'Contabilidade',
    categorySlug: 'contabilidade',
    author: {
      name: 'Dra. Ana Paula Lima',
      role: 'Especialista em Contabilidade',
      avatar: ''
    },
    date: '2025-01-10',
    readTime: '18 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20office%20modern%20workspace%20fixed%20assets%20management%20accounting%20financial%20planning%20organized%20workspace%20business%20equipment%20technology%20infrastructure%20corporate%20environment&width=800&height=450&seq=gestao-ativos-fixos-1&orientation=landscape',
    featured: true
  },
  {
    id: 2,
    title: 'Automação Contábil: O Futuro da Profissão',
    slug: 'automacao-contabil',
    excerpt: 'Como a automação está transformando a rotina dos contadores e escritórios contábeis.',
    category: 'Tecnologia',
    categorySlug: 'tecnologia',
    author: {
      name: 'Dr. Carlos Mendes',
      role: 'Especialista em Tecnologia',
      avatar: ''
    },
    date: '2025-01-08',
    readTime: '12 min',
    image: 'https://readdy.ai/api/search-image?query=modern%20professional%20office%20with%20advanced%20technology%20automated%20accounting%20systems%20digital%20workspace%20futuristic%20business%20environment%20computers%20screens%20data%20analysis%20sleek%20contemporary%20design&width=800&height=450&seq=automacao-contabil-1&orientation=landscape',
    featured: true
  },
  {
    id: 3,
    title: 'eSocial 2026: Mudanças e Obrigações',
    slug: 'esocial-2026',
    excerpt: 'Prepare-se para as novas obrigações do eSocial que entram em vigor em 2026.',
    category: 'Departamento Pessoal',
    categorySlug: 'departamento-pessoal',
    author: {
      name: 'Dra. Beatriz Costa',
      role: 'Especialista em Departamento Pessoal',
      avatar: ''
    },
    date: '2025-01-06',
    readTime: '15 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20meeting%20discussing%20digital%20transformation%20HR%20compliance%20modern%20corporate%20office%20team%20collaboration%20eSocial%20technology%20planning%20strategic%20discussion%20contemporary%20workspace&width=800&height=450&seq=esocial-2026-1&orientation=landscape',
    featured: true
  },
  {
    id: 4,
    title: 'Reforma Tributária: Impactos no Lucro Presumido e Lucro Real',
    slug: 'reforma-tributaria-lucro-presumido-real',
    excerpt: 'Análise técnica completa sobre os efeitos da reforma tributária nos regimes de Lucro Presumido e Lucro Real: CBS, IBS, créditos e estratégias.',
    category: 'Tributário',
    categorySlug: 'tributario',
    author: {
      name: 'Dr. Ricardo Almeida',
      role: 'Especialista em Tributário',
      avatar: ''
    },
    date: '2025-01-22',
    readTime: '20 min',
    image: 'https://readdy.ai/api/search-image?query=business%20professional%20analyzing%20tax%20reform%20financial%20data%20computer%20screens%20charts%20graphs%20lucro%20presumido%20lucro%20real%20modern%20office%20workspace%20accounting%20planning%20strategy&width=800&height=450&seq=reforma-lucro-thumb&orientation=landscape',
    featured: false
  },
  {
    id: 5,
    title: 'Fim do CIAP do PIS/COFINS com a Reforma Tributária?',
    slug: 'fim-ciap-pis-cofins-reforma-tributaria',
    excerpt: 'Análise técnica sobre o futuro do CIAP no contexto da extinção do PIS/COFINS e implementação da CBS: transição, créditos em andamento e impactos práticos.',
    category: 'Tributário',
    categorySlug: 'tributario',
    author: {
      name: 'Dr. Fernando Silva',
      role: 'Especialista em Créditos Tributários',
      avatar: ''
    },
    date: '2025-01-22',
    readTime: '18 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20accountant%20analyzing%20tax%20credits%20CIAP%20documents%20financial%20planning%20spreadsheets%20modern%20office%20workspace%20tax%20reform%20strategy%20business%20planning&width=800&height=450&seq=ciap-thumb&orientation=landscape',
    featured: false
  },
  {
    id: 'ciap-reforma-tributaria',
    title: 'CIAP na Reforma Tributária: como ficam os créditos do ativo imobilizado com IBS e CBS',
    slug: 'ciap-reforma-tributaria',
    excerpt: 'Entenda o fim do modelo tradicional do CIAP do ICMS e a nova lógica de creditamento imediato no sistema de IVA dual.',
    category: 'Reforma Tributária',
    categorySlug: 'reforma-tributaria',
    author: {
      name: 'Dr. Marcos Oliveira',
      role: 'Especialista em Créditos Tributários',
      avatar: ''
    },
    date: '2025-01-23',
    readTime: '12 min',
    image: 'https://readdy.ai/api/search-image?query=modern%20industrial%20facility%20with%20advanced%20machinery%20equipment%20and%20technology%20infrastructure%20representing%20fixed%20assets%20and%20capital%20investments%20in%20professional%20corporate%20environment%20with%20clean%20organized%20layout&width=800&height=450&seq=ciap-reforma-thumb&orientation=landscape',
    featured: false
  },
  {
    id: 6,
    title: 'Inventário de Estoques: Como Ajustar Perdas e Adições',
    slug: 'inventario-estoques-ajustes-perdas',
    excerpt: 'Guia técnico completo sobre como realizar inventário de estoques e tratar corretamente perdas, adições e discrepâncias sob aspectos contábeis e fiscais.',
    category: 'Contabilidade',
    categorySlug: 'contabilidade',
    author: {
      name: 'Dra. Paula Santos',
      role: 'Especialista em Contabilidade de Custos',
      avatar: ''
    },
    date: '2025-01-22',
    readTime: '22 min',
    image: 'https://readdy.ai/api/search-image?query=warehouse%20inventory%20management%20professional%20team%20counting%20stock%20products%20shelves%20modern%20logistics%20facility%20barcode%20scanner%20inventory%20control%20quality%20assurance&width=800&height=450&seq=inventory-thumb&orientation=landscape',
    featured: false
  },
  {
    id: 7,
    title: 'Reforma Tributária e eSocial: Integração Necessária',
    slug: 'reforma-esocial',
    excerpt: 'Como a reforma tributária impacta as obrigações acessórias e a integração com o eSocial.',
    category: 'Tributário',
    categorySlug: 'tributario',
    author: {
      name: 'Dr. Roberto Farias',
      role: 'Especialista em Tributário',
      avatar: ''
    },
    date: '2025-01-05',
    readTime: '14 min',
    image: 'https://readdy.ai/api/search-image?query=modern%20business%20office%20professional%20team%20analyzing%20digital%20tax%20documents%20compliance%20planning%20collaborative%20workspace%20contemporary%20design%20technology%20integration%20strategy%20meeting&width=800&height=450&seq=reforma-esocial-1&orientation=landscape',
    featured: false
  },
  {
    id: 8,
    title: 'Gestão de Folha de Pagamento: Guia Completo',
    slug: 'folha-pagamento',
    excerpt: 'Tudo o que você precisa saber sobre gestão eficiente de folha de pagamento e departamento pessoal.',
    category: 'Departamento Pessoal',
    author: {
      name: 'Dra. Camila Rodrigues',
      avatar: ''
    },
    date: '2025-01-04',
    readTime: '15 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20HR%20department%20office%20modern%20workspace%20payroll%20management%20team%20collaboration%20organized%20desk%20computers%20financial%20documents%20contemporary%20business%20environment%20efficient%20workflow&width=800&height=450&seq=folha-pagamento-1&orientation=landscape',
    featured: false
  },
  {
    id: 9,
    title: 'Planejamento Tributário: Como Economizar Legalmente',
    slug: 'planejamento-tributario',
    excerpt: 'Estratégias práticas de planejamento tributário para reduzir a carga fiscal da sua empresa de forma legal.',
    category: 'Tributário',
    author: {
      name: 'Dr. Marcelo Tavares',
      avatar: ''
    },
    date: '2025-01-03',
    readTime: '16 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20consultant%20analyzing%20tax%20planning%20documents%20modern%20office%20workspace%20financial%20strategy%20charts%20graphs%20contemporary%20design%20strategic%20planning%20meeting%20business%20professional&width=800&height=450&seq=planejamento-tributario-1&orientation=landscape',
    featured: false
  },
  {
    id: 10,
    title: 'O Papel do Contador na Era da IA',
    slug: 'contador-ia',
    excerpt: 'Como a inteligência artificial está transformando a profissão contábil e criando novas oportunidades.',
    category: 'Tecnologia',
    author: {
      name: 'Dra. Juliana Campos',
      avatar: ''
    },
    date: '2025-01-02',
    readTime: '13 min',
    image: 'https://readdy.ai/api/search-image?query=modern%20professional%20office%20with%20artificial%20intelligence%20technology%20futuristic%20workspace%20digital%20transformation%20business%20environment%20sleek%20contemporary%20design%20advanced%20technology%20screens%20data%20visualization&width=800&height=450&seq=contador-ia-1&orientation=landscape',
    featured: false
  },
  {
    id: 11,
    title: 'Como Administrar um Escritório Contábil de Sucesso',
    slug: 'escritorio-contabil',
    excerpt: 'Dicas práticas para gestão eficiente de escritórios contábeis: organização, tecnologia e atendimento ao cliente.',
    category: 'Gestão',
    author: {
      name: 'Dr. Eduardo Martins',
      avatar: ''
    },
    date: '2025-01-01',
    readTime: '17 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20modern%20accounting%20office%20organized%20workspace%20successful%20business%20environment%20team%20collaboration%20contemporary%20design%20efficient%20workflow%20clean%20organized%20workspace%20business%20management&width=800&height=450&seq=escritorio-contabil-1&orientation=landscape',
    featured: false
  },
  {
    id: 12,
    title: 'Recrutamento e Seleção: Melhores Práticas para o DP',
    slug: 'recrutamento-selecao-melhores-praticas-dp',
    excerpt: 'Guia completo sobre as melhores práticas de Recrutamento e Seleção para o Departamento Pessoal, com foco em conformidade legal.',
    category: 'Departamento Pessoal',
    author: {
      name: 'Dra. Mariana Costa',
      avatar: ''
    },
    date: '2024-12-30',
    readTime: '12 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20recruitment%20interview%20modern%20office%20HR%20manager%20meeting%20candidate%20contemporary%20workspace%20hiring%20process%20professional%20environment%20job%20interview%20corporate%20setting&width=800&height=450&seq=recrutamento-selecao-1&orientation=landscape',
    featured: false
  }
];

// Posts para o carrossel hero (destaque principal)
export const heroCarouselPosts = [
  blogPosts[0], // Como Administrar um Escritório Contábil
  blogPosts[1], // O Papel do Contador na Era da IA
  blogPosts[2], // Planejamento Tributário
];

// Posts recentes para a seção de blog
export const recentPosts = blogPosts.slice(0, 6);

// Todos os posts (para páginas de listagem)
export const allPosts: BlogPost[] = [
  {
    id: 2,
    slug: 'gestao-ativos-fixos-controle-patrimonial',
    title: 'Gestão de Ativos Fixos: Controle Patrimonial Completo',
    excerpt: 'Guia definitivo sobre gestão de ativos fixos: classificação, depreciação, controle, inventário e compliance fiscal.',
    category: 'Contabilidade',
    date: '2025-01-25',
    readTime: '12 min',
    image: 'https://readdy.ai/api/search-image?query=corporate%20asset%20management%20warehouse%20inventory%20control%20modern%20facility%20organization%20business%20equipment%20machinery%20professional%20lighting%20clean%20organized%20space%20industrial%20setting&width=800&height=400&seq=gestao-ativos-fixos-complete&orientation=landscape',
    author: {
      name: 'Carlos Silva',
      role: 'Especialista em Patrimônio',
      avatar: ''
    }
  },
  {
    id: 3,
    slug: 'automacao-contabil-ferramentas-essenciais',
    title: 'Automação Contábil: Ferramentas Essenciais',
    excerpt: 'Descubra as principais ferramentas de automação que estão transformando a contabilidade moderna.',
    category: 'Tecnologia',
    date: '2025-01-20',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=modern%20accounting%20automation%20software%20digital%20transformation%20professional%20workspace%20business%20technology%20clean%20interface%20analytics%20dashboard%20contemporary%20office&width=800&height=400&seq=automacao-contabil-complete&orientation=landscape',
    author: {
      name: 'Ana Santos',
      role: 'Consultora de Tecnologia',
      avatar: ''
    }
  },
  {
    id: 4,
    slug: 'esocial-guia-completo-empresas-2026',
    title: 'eSocial: Guia Completo para Empresas (2026)',
    excerpt: 'Tudo o que você precisa saber sobre eSocial: eventos, prazos, obrigações e como evitar multas em 2026.',
    category: 'Departamento Pessoal',
    date: '2025-01-18',
    readTime: '15 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20HR%20department%20modern%20office%20business%20compliance%20documentation%20digital%20system%20organized%20workspace%20clean%20contemporary%20design%20employees%20working%20computers%20data%20management&width=800&height=400&seq=esocial-guia-complete&orientation=landscape',
    author: {
      name: 'Roberto Oliveira',
      role: 'Especialista em eSocial',
      avatar: ''
    }
  },
  {
    id: 5,
    slug: 'reforma-tributaria-esocial-guia-completo',
    title: 'Reforma Tributária e eSocial: Guia Completo',
    excerpt: 'Entenda como a Reforma Tributária impacta o eSocial e o que sua empresa precisa fazer para se preparar.',
    category: 'Tributário',
    date: '2025-01-15',
    readTime: '20 min',
    image: 'https://readdy.ai/api/search-image?query=tax%20reform%20brazil%20business%20meeting%20professional%20office%20financial%20planning%20documents%20charts%20analysis%20corporate%20environment%20modern%20workspace%20serious%20discussion&width=800&height=400&seq=reforma-esocial-complete&orientation=landscape',
    author: {
      name: 'Dr. Paulo Mendes',
      role: 'Especialista em Tributário',
      avatar: ''
    }
  },
  {
    id: 6,
    slug: 'gestao-folha-pagamento-guia-completo',
    title: 'Gestão de Folha de Pagamento: Guia Completo',
    excerpt: 'Tudo o que você precisa saber sobre gestão eficiente de folha de pagamento e departamento pessoal.',
    category: 'Departamento Pessoal',
    date: '2025-01-05',
    readTime: '15 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20payroll%20management%20HR%20department%20modern%20office%20team%20working%20with%20documents%20computers%20organized%20workspace%20business%20professionals%20light%20neutral%20background%20clean%20photography%20high%20quality&width=800&height=400&seq=folha-pagamento-hero-complete&orientation=landscape',
    author: {
      name: 'Dra. Camila Rodrigues',
      role: 'Especialista em Departamento Pessoal',
      avatar: ''
    }
  },
  {
    id: 7,
    slug: 'planejamento-tributario',
    title: 'Planejamento Tributário: Como Economizar Legalmente',
    excerpt: 'Estratégias práticas de planejamento tributário para reduzir carga fiscal de forma legal e segura.',
    category: 'Tributário',
    date: '2025-01-02',
    readTime: '10 min',
    image: 'https://readdy.ai/api/search-image?query=tax%20planning%20business%20strategy%20financial%20analysis%20professional%20office%20modern%20workspace%20documents%20charts%20calculator%20organized%20desk%20corporate%20environment&width=800&height=400&seq=planejamento-tributario-complete&orientation=landscape',
    author: {
      name: 'Dr. Paulo Mendes',
      role: 'Especialista em Planejamento Tributário',
      avatar: ''
    }
  },
  {
    id: 8,
    slug: 'papel-contador-era-inteligencia-artificial',
    title: 'O Papel do Contador na Era da Inteligência Artificial',
    excerpt: 'Como a IA está transformando a profissão contábil e o que os profissionais precisam fazer para se adaptar.',
    category: 'Tecnologia',
    date: '2024-12-28',
    readTime: '12 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20accountant%20working%20with%20AI%20artificial%20intelligence%20modern%20office%20technology%20digital%20transformation%20business%20analytics%20data%20visualization%20futuristic%20workspace&width=800&height=400&seq=contador-ia-complete&orientation=landscape',
    author: {
      name: 'Dra. Julia Martins',
      role: 'Especialista em Tecnologia Contábil',
      avatar: ''
    }
  },
  {
    id: 9,
    slug: 'como-administrar-escritorio-contabil-sucesso',
    title: 'Como Administrar um Escritório Contábil com Sucesso',
    excerpt: 'Dicas práticas de gestão, tecnologia e relacionamento com clientes para escritórios contábeis modernos.',
    category: 'Gestão',
    date: '2024-12-20',
    readTime: '14 min',
    image: 'https://readdy.ai/api/search-image?query=modern%20accounting%20office%20professional%20workspace%20business%20management%20team%20meeting%20organized%20space%20contemporary%20design%20computers%20documents%20collaboration%20productive%20environment&width=800&height=400&seq=escritorio-contabil-complete&orientation=landscape',
    author: {
      name: 'Carlos Mendes',
      role: 'Consultor de Gestão Contábil',
      avatar: ''
    }
  },
  {
    id: 10,
    slug: 'recrutamento-selecao-melhores-praticas-dp',
    title: 'Recrutamento e Seleção: Melhores Práticas para o DP',
    excerpt: 'Guia técnico completo sobre recrutamento e seleção para o DP: planejamento, triagem, entrevistas estruturadas, documentação admissional e compliance.',
    category: 'Departamento Pessoal',
    date: '2024-11-20',
    readTime: '12 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20HR%20recruitment%20process%20job%20interview%20modern%20office%20business%20meeting%20candidate%20selection%20structured%20interview%20corporate%20environment%20professional%20lighting%20clean%20design&width=800&height=400&seq=recrutamento-selecao-dp-hero&orientation=landscape',
    author: {
      name: 'Dra. Mariana Costa',
      role: 'Especialista em RH e Gestão de Pessoas',
      avatar: ''
    }
  }
];

// Post em destaque (featured)
export const featuredPost = blogPosts[1]; // O Papel do Contador na Era da IA

// Categorias disponíveis
export const categories = [
  {
    id: 1,
    name: 'Ativo Fixo & Patrimônio',
    slug: 'ativo-fixo-patrimonio',
    description: 'Gestão de ativos e patrimônio empresarial',
    icon: 'ri-building-line',
    color: 'from-blue-500 to-cyan-500',
    count: 4,
  },
  {
    id: 2,
    name: 'Tecnologia',
    slug: 'tecnologia',
    description: 'Inovação e transformação digital na contabilidade',
    icon: 'ri-computer-line',
    color: 'from-purple-500 to-pink-500',
    count: 5,
  },
  {
    id: 3,
    name: 'Fiscal & Tributário',
    slug: 'fiscal-tributario',
    description: 'Planejamento tributário e compliance fiscal',
    icon: 'ri-file-text-line',
    color: 'from-green-500 to-emerald-500',
    count: 5,
  },
  {
    id: 4,
    name: 'Departamento Pessoal',
    slug: 'departamento-pessoal',
    description: 'Gestão de folha de pagamento e RH',
    icon: 'ri-team-line',
    color: 'from-orange-500 to-amber-500',
    count: 4,
  },
];
